
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/frontend-dev",
      function () {
        return require("private-next-pages/services/frontend-dev.tsx");
      }
    ]);
  